export enum PriceRounding {
    NO_ROUND = 'NO_ROUND',
    CEIL_INT = 'CEIL_INT',
    NEAREST_INT = 'NEAREST_INT',
}
